(function Module() {
	'use strict';
	mySynch.controller('ReviewDraftReportV1_3Controller', [
		'$scope',
		'$rootScope',
		'$interval',
		'$q',
		'F360Service',
		'AuditService',
		'ApiFactory',
		'F360Constant',
		'F360ChartService',
		'CookieFactory',
		'$location',
		'$filter',
		'$window',
		'$anchorScroll',
		'MySynchFactory',
		'clientLoggerService',
		function ReviewDraftReportV1_3Controller($s,$rootScope,$interval,$q, f360Service, auditService,api,constant, ChartService,cookies, $location,$filter,$window,$anchorScroll,MSF, log) {
			window.scrollTo(0, 0);
			console.log("@@@@@@@@@ V1.3 Review Draft @@@@@@@@");
			self.auditId = auditService.getAuditId($location.url());
			
			$s.breadcrumbs = f360Service.getReport360Breadcrumbs();
			$s.lastBreadcrumbs = $s.breadcrumbs.pop();

			$s.isOnline = $rootScope.onLine;

			$s.auditApiVersion;
			$s.mySynchState = {};
			$s.activeFarm = {};
			$s.currentHerd = {};


			$s.overViewList = [];
			$s.auditAnswers = [];
			$s.auditQuestions = [];

			$s.sectionsQuestionsAndAnswers = [];
			$s.followupItems = [];
			$s.actionItemGroups = [];
			$s.actionItems = [];

			$s.isEditingActionItemGroup = false;
			$s.isEditingActionItem = false;
			$s.currentActionItemGroup = {};
			$s.currentActionItem = {};
			$s.currentActionItemGroupRef = {};
			$s.currentActionItemRef = {};

			$s.actionItemGroupKeyErrorText = "";
			$s.actionItemGroupKeyFreeTextErrorText = "";
        

			$s.people = [];



			$s.codeFile = [];


			$s.actionItemGroupTmpl;
			$s.actionItemTmpl;

			


			let testActionItemGroup = {
				actionItemGroupKey: "Fertility",
				description: "test action group involving Fertility",
				actionItems: [],
				associatedMetrics: ""
			};

			let testAssociatedMetrics = [
				{
					name: "Pregnancy Rate RHA"
				},
				{
					name: "Conception Rate RHA"
				}
			];

			let testPeople = [{ personId: 1, fullName: "Mary Smith" }, { personId: 1080, fullName: "Matthew Doucet" }, { personId: 1077, fullName: "Brandon Dugan" }];

			let testActionItems = [
				{
					actionItemGroup : "Fertility",
					dueDate: moment(new Date(2022,12,15)).format('M/D/YYYY'),
					displayDueDate: new Date(2022,12,15),
					description: "This is free text copy entered by the vet creating an action item. This is free text copy entered by the vet creating an action item. This is free text copy entered by the vet creating an action item. This is free text copy entered by the vet creating an action item. ",
					person: { personId: 1080, fullName: "Matthew Doucet" },
					personId: 1080,
					fullName: "Matthew Doucet",
					status: "A",
					dateCompleted: null,
					dateRemoved: null,
					currentFarmGoal: "Test Farm Goal"

				},
				{
					actionItemGroup : "Fertility",
					dueDate: moment(new Date(2022,12,16)).format('M/D/YYYY'),
					displayDueDate: new Date(2022,12,16),
					description: "This is a list of actions to complete to meet the goal.",
					personId: 1080,
					fullName: "Matthew Doucet",
					person: { personId: 1080, fullName: "Matthew Doucet" },
					status: "A",
					dateCompleted: null,
					dateRemoved: null,
					currentFarmGoal: "Test Farm Goal"
				},
				{
					actionItemGroup : "Fertility",
					dueDate: moment(new Date(2022,12,17)).format('M/D/YYYY'),
					displayDueDate: new Date(2022,12,17),
					description: "Description goes here.",
					personId: 1080,
					fullName: "Matthew Doucet",
					person: { personId: 1080, fullName: "Matthew Doucet" },
					status: "A",
					dateCompleted: null,
					dateRemoved: null,
					currentFarmGoal: "Test Farm Goal"
				}
			];


			

			$s.allMetGuidelineQuestions = [];
			$s.allOutsideGuidelineQuestions = [];
			$s.allMetGuidelineQuestionsWithGuidelines = [];
			$s.allOutsideGuidelineQuestionsWithGuidelines = [];
		  
		

			$s.defaultReportData = {"resultsWriteRptJson":{"formattedHighlights":"","nextEvaluationDate":"","comments":[{"section": "FARMWALKTHRU","formattedComments":""},{"section": "INTERVIEW","formattedComments":""},{"section": "DATAQUALITY","formattedComments":""},{"section": "REPRODUCTIVITY","formattedComments":""},{"section": "FRESHCOWDISEASE","formattedComments":""}]},"reviewDraftRptJson":{"reportDate":"","milkingCnt": null,"pregRate":null,"concRate":null,"reviewedReport":false,"actionItemGroups":[]}};
			$s.reportData = {};
			$s.report = angular.copy($s.defaultReportData);
			

				//--------- chart variables
				$s.overallSummaryPieChart = {
					chart: {},
					title: "",
					seriesData: [] 
				};
			
				$s.sectionBarChart = {
					chart: {},
					title: "",
					seriesData: []
				};
				$s.categoryBarChart = {
					chart: {},
					title: "",
					seriesData: []
				};
	
				$s.questionSectionsPieChartData = [];
		 
			$s.codeFileQuestionCategories = _.filter($s.codeFile,{codeType: "F360CATEGORY"});

			$s.codeFileActionItemGroups = _.filter($s.codeFile, { codeType: "ACTIONITEMGROUP" });

			$s.codeFileActionItemGroupMetrics = _.filter($s.codeFile, { codeType: "ACTIONITEMMETRIC" });
				
			//-------------------

			$s.currentTopAnchor = "";
              
			//$s.minTargetDate = moment().set({'hour':0,'minute':0,'second':0,"millisecond":0}).toDate();
			 
			$s.reportDate = moment().toDate();//formatDateString(new Date()); 
			$s.veterinarian = ""; 

			$s.pregRateQuestionId = 145;
			$s.concRateQuestionId = 127;

			// watcher degresigration variables
			var deregOnFarmChange = undefined;
			var deregOnlineCheckWatch = undefined;

			// flag for that is set true when and update answers or publish audit call occurs successfuly without updating the server
			$s.syncInProgress = false;
			$s.isDirty = false;
			$s.updateInProgress = false;

			$s.checkSyncStatusTimer = undefined;

			$(document).ready(function () {
				window.scrollTo(0,0);
			});

			$s.checkPermissions = function checkPermissions(callback){
				
				// we need to check to see if the user who is viewing this screen is the person who create the audit
				// otherwise we need to redirect them to the top level f360 report
				auditService.getListByHerdId(function getF360ListByHerdId(err, data) {
					var auditHerd = _.find(data,{AuditId: self.auditId},'Name');
					 
					if(!_.isEqual(_.get(auditHerd,'PersonId'),_.get(cookies.user,'PersonId'))){
						MSF.loadPage('Fertility360report');
					}

					callback();

				});
			};

		
            function formatDate(date){
				var formattedDate = null;
				if(!_.isNull(date)){					
				
		      
					formattedDate = moment(date).toDate();//new Date($filter("date")(date,'MM/dd/yyyy'));
			    	//	formattedDate = moment(date).subtract(moment(date).utcOffset(), 'minutes').toDate()
				}
				
				 
				return formattedDate;
			}
			function formatDateString(date){
					
                 var stringDate = null;
				 if(!_.isNull(date)){
				
	     			//stringDate = moment(date).subtract(moment(date).utcOffset(), 'minutes').utc().format();
					 stringDate = moment(date).format('MM/DD/YYYY');
				}
				return stringDate;
			}
			function formatDateTimeString(date){
					
				var stringDate = null;
				if(!_.isNull(date)){
			   
					stringDate = moment(date).subtract(moment(date).utcOffset(), 'minutes').utc().format();
					//stringDate = moment(date).format('MM/DD/YYYY');
			   }
			   return stringDate;
		   }
			function getDaysInMonth(year, month) {
			   return new Date(year, month, 0).getDate();	
			}
			function getMaxNextEvaluationDate(input,months){
				const date = new Date(input);
				date.setDate(1);
				date.setMonth(date.getMonth() + months);
				date.setDate(Math.min(input.getDate(), getDaysInMonth(date.getFullYear(), date.getMonth()+1)));
				return moment(date);
			}
			function buildReportData(){

       

				
			   
				// resultsWriteRptJson data 

				// in the database next evaluation date is stored as a string, the date input control requires a date
				_.set($s.report,'resultsWriteRptJson.formattedHighlights',_.get($s.reportData,'resultsWriteRptJson.formattedHighlights',""));
			//	_.set($s.report,'resultsWriteRptJson.nextEvaluationDate',formatDate(_.get($s.reportData,'resultsWriteRptJson.nextEvaluationDate',"")));
				_.set($s.report,'resultsWriteRptJson.nextEvaluationDate',_.get($s.reportData,'resultsWriteRptJson.nextEvaluationDate',""));
				
				var resultsWriteRptData = _.get($s.reportData,'resultsWriteRptJson');
				if(!_.isUndefined(resultsWriteRptData)){
					_.set($s.report,'resultsWriteRptJson.formattedHighlights',_.get(resultsWriteRptData,'formattedHighlights',""));
				//	_.set($s.report,'resultsWriteRptJson.nextEvaluationDate',formatDate(_.get(resultsWriteRptData,'nextEvaluationDate',"")));
				_.set($s.report,'resultsWriteRptJson.nextEvaluationDate',_.get(resultsWriteRptData,'nextEvaluationDate',""));
	
					_.forEach($s.report.resultsWriteRptJson.comments,function(comment,index){
						_.set(comment,'formattedComments',_.get(resultsWriteRptData,'comments['+index+'].formattedComments',""));
					});
				}
	
				
 
				 // reviewDraftRptJson data and report specific reviewDraftRptJson data
			//	_.set($s.report,'reviewDraftRptJson.reportDate',$s.reportDate);

				     setVeterinarianName();
				

					_.set($s.report,'reviewDraftRptJson.reportDate',$s.reportDate);
					_.set($s.report,'reviewDraftRptJson.milkingCnt', _.get($s.reportData,'reviewDraftRptJson.milkingCnt'), "");
					_.set($s.report,'reviewDraftRptJson.pregRate',getRateValueByQuestionId($s.pregRateQuestionId));		
					_.set($s.report,'reviewDraftRptJson.concRate',getRateValueByQuestionId($s.concRateQuestionId));
					if(_.isUndefined(_.get($s.report,'reviewDraftRptJson.reviewedReport'))){
						_.set($s.report,'reviewDraftRptJson.reviewedReport',false);
					}
					// action item groups and items
					_.set($s.report,'reviewDraftRptJson.actionItemGroups',_.get($s.reportData,'reviewDraftRptJson.actionItemGroups',[]));
				    $s.actionItemGroups =  _.get($s.reportData,'reviewDraftRptJson.actionItemGroups',[]);

					_.forEach($s.actionItemGroups,function(actionItemGroup){
						_.set(actionItemGroup,'AssociatedMetricsDisplay',
						    //    _.map( _.pluck(_.get(actionItemGroup,'AssociatedMetrics',[]),'Metric'),function(metric){
                            //             var displayMetricName = metric
							// 			var metricCodeValue = _.get(_.find($s.codeFile,{codeType: "ACTIONITEMMETRIC",code:metric}),'codeValue')
							// 			if(!_.isUndefined(metricCodeValue)){
							// 				displayMetricName = metricCodeValue;
							// 			}
							// 			return displayMetricName;
							//    }).join(",")
							$s.getAssociatedMetricsStringList(_.get(actionItemGroup,'AssociatedMetrics',[]),"Metric",",")
					     );
					});

					// farm admin list

					$s.people = _.map( _.filter(_.get(MSF,'lists.personActiveFarmAdmins',[]),{farmId: _.get($s.activeFarm,'farmId')}), function(farmAdmin){
                                        return {
											      FarmId: 	    _.get(farmAdmin,'farmId'),
											      PersonId: 	_.get(farmAdmin,'personId'),
											      FirstName: 	_.get(farmAdmin,'firstName'),
										     	  LastName: 	_.get(farmAdmin,'lastName'),
										    	  FullName: 	_.get(farmAdmin,'fullName')

										  };
					            });

					

			}
			$s.getAssociatedMetricsStringList = function getAssociatedMetricsStringList(metricsArray,fieldName,seperator){
                    var stringList = "";
					if(_.get(metricsArray,'length') > 0){

						var fieldCodes = _.pluck(metricsArray,fieldName);
						var dispalyValues = _.map( fieldCodes,function(metricCode){
													var displayMetricName = metricCode;
															var metricCodeValue = _.get(_.find($s.codeFile,{codeType: "ACTIONITEMMETRIC",code:metricCode}),'codeValue');
															if(!_.isUndefined(metricCodeValue)){
																displayMetricName = metricCodeValue;
															}
															return displayMetricName;
												});
						if(_.get(dispalyValues,'length') > 0){
							stringList = dispalyValues.join(seperator);
						}
						
					}
				
				return stringList;
			};
			function loadCurrentHerd(callback){
				   
				auditService.getHerdsByFarmId(_.get($s.activeFarm,'farmId'), function getF360HerdsByFarmId(err, herd){
					  if (err) {
						  console.log('err', err);
					  }
						$s.currentHerd =  herd[0];
						var currentHMS = _.get($s.currentHerd,'herdMgmtSoftware');
								   //if the farm doesn't currently have the F360  module on we will want to redirect the user that got here
					
						  if(_.isNull(currentHMS) || _.isUndefined(currentHMS)){
							 MSF.loadPage('Login');
						  }
			  
					  callback();       
				});

			 
		  }
			function setVeterinarianName(){

				auditService.getListByHerdId(function getF360ListByHerdId(err, data) {
					var auditHerd = _.find(data,{AuditId: self.auditId},'Name');  
					$s.veterinarian = _.get(auditHerd,'Name',"");
					$s.$applyAsync();
				});

			}
			
			function getRateValueByQuestionId(questionId){
				var rateValue = "";
				var answer = _.find($s.auditAnswers,{QuestionId:questionId});

				if(answer){
				   var value = _.get(answer,'AnswerDetailsJson.Value',"");
				   if(!_.isNull(value) && !_.isEqual(value,"")){
					   rateValue = value;
				   } 
				}

                return rateValue;
			} 
			function removeExcludedQuestions(){
				var notApplicableQuestion = _.find($s.auditQuestions, function(question) {
					return _.isEqual(question.SubHeading,"Dry Cows Far-Off") && _.isEqual(question.QuestionTemplate,"TF");
				  
				  });
			 if(!_.isUndefined(notApplicableQuestion)){
				  var notApplicableQuestionAnswer = _.find($s.auditAnswers,"QuestionId",notApplicableQuestion.QuestionId);	
				  if(_.isEqual(_.get(notApplicableQuestionAnswer,'AnswerDetailsJson.Value',constant.answerFalse),constant.answerTrue)){
					  //if the not applicable TF question is true (checked), we first want to exclude any calculated question that is dependent on the questions in the not applicable TF question's subheading
					   var excludedQuestionIds = [];
					   var subHeadingQuestions = _.filter($s.auditQuestions,{SubHeading: notApplicableQuestion.SubHeading});
					   _.forEach(subHeadingQuestions,function(subHeadingQuestion){
						  var calcTags = _.get(subHeadingQuestion,'QuestionDetailsJson.calcTag',null);
						  
						  if(!_.isNull(calcTags)){
							  _.forEach(calcTags,function(calcTag){
								 
								  var calcQuestion = _.find($s.auditQuestions,function(question){ 
													  
														  var calcVarArray = _.get(question,'QuestionDetailsJson.calculations.calculationVars');
														  if(!_.isUndefined(calcVarArray) && !_.isEmpty(calcVarArray)){
																  var valueTagObjects = [];
	
																  _.forEach(calcVarArray,function(calcVarObject){
																	  var calcVarObjectKey = _.keys(calcVarObject)[0];
																	  valueTagObjects.push(calcVarObject[calcVarObjectKey]);
																	  //var valueTagArray = calcVarObject[calcVarObjectKey].valueTag;
																  //	valueTags = _.union(valueTags,valueTagArray);
																	  
																  });
																  var calcQuestionMatch = false;
																  _.forEach(valueTagObjects,function(valueTagObject){
																	  if(_.isEqual(subHeadingQuestion.SubHeading,valueTagObject.subHeading) && _.includes(valueTagObject.valueTag,calcTag)){
																		  calcQuestionMatch = true;
																		  return false;		
																	  }
	
																  });
	
	
																  return calcQuestionMatch;
														  }
													   
														  
													  });
									 if(!_.isUndefined(calcQuestion) && !_.includes(excludedQuestionIds,calcQuestion.QuestionId)){
										 excludedQuestionIds.push(calcQuestion.QuestionId);
									 }	
							  });
						  }
						  
					   });
	
					  
					  // then  we want to exclude the questions in that subheading for the counts on the overview screen
					  $s.auditQuestions = _.reject($s.auditQuestions,function(question){ return _.isEqual(question.SubHeading,notApplicableQuestion.SubHeading) || _.includes(excludedQuestionIds,question.QuestionId);});
	
					 
					 
				  }else{
					  //even if the not applicable question is false, we still don't want to include it in the answer count
					  $s.auditQuestions = _.reject($s.auditQuestions,function(question){ return _.isEqual(question.QuestionId,notApplicableQuestion.QuestionId);});
				  }	   
			 }
			}
			function buildSectionsQuestionsAndAnswers(){
				
				_.forEach($s.overViewList,function(section){
					var sectionQuestionAnswerObj = {}; 
					var sectionName = $filter("SectionName")(section.Section);
					_.set(sectionQuestionAnswerObj,'sectionName',sectionName);
					var sectionQuestions = _.filter($s.auditQuestions,function(question){return question.Section === section.Section && question.QuestionId != 1;});
					var metGuidelineQuestions = [];
					var outsideGuidelineQuestions = [];
	
					_.forEach(sectionQuestions,function(question){
						var answer = _.get(_.find($s.auditAnswers,{QuestionId: question.QuestionId}),'AnswerDetailsJson');

						 // need to convert the date proprties from their string form to date form 
						// _.set(answer,'TargetDate',formatDate(_.get(answer,'TargetDate',null))); 
					
						
						_.set(question,'Answer',angular.copy(answer));
	
					
	 
						
						if(_.isEqual(question.Answer.MetGuideline,false)){
							outsideGuidelineQuestions.push(question);
						}else{
							metGuidelineQuestions.push(question);
						}
						
					});
	
					_.set(sectionQuestionAnswerObj,'metGuidelineQuestions',metGuidelineQuestions);
					_.set(sectionQuestionAnswerObj,'outsideGuidelineQuestions',outsideGuidelineQuestions);
					
					$s.sectionsQuestionsAndAnswers.push(sectionQuestionAnswerObj);

					$s.allOutsideGuidelineQuestions = $s.allOutsideGuidelineQuestions.concat(outsideGuidelineQuestions);
			    	$s.allMetGuidelineQuestions = $s.allMetGuidelineQuestions.concat(metGuidelineQuestions);
	
				}); 


				$s.allMetGuidelineQuestionsWithGuidelines = _.filter($s.allMetGuidelineQuestions,function(question){ return !_.isUndefined(_.get(question,'QuestionDetailsJson.industryGuideline.compare'));}); 
		    	$s.allOutsideGuidelineQuestionsWithGuidelines = _.filter($s.allOutsideGuidelineQuestions,function(question){ return !_.isUndefined(_.get(question,'QuestionDetailsJson.industryGuideline.compare'));});
		   
			
			}

			function loadPieCharts(){
				//all data for pie charts are for questions that have an industry guideline
				
				// overall summary pie chart 
				_.set($s.overallSummaryPieChart,'title',"Questions that Met Industry Guideline");
				
		
				var overallSummaryQuestionData = [
					{name: "Met Guideline", data: $s.allMetGuidelineQuestionsWithGuidelines.length},
					{name: "Did Not Meet Guideline", data: $s.allOutsideGuidelineQuestionsWithGuidelines.length}
				];
				_.set($s.overallSummaryPieChart,'seriesData',overallSummaryQuestionData);

				var overallPieChartCanvasElement = document.getElementById("overallSummaryPieChart");// $('#overallSummaryPieChart')[0];
				var overallPieChartElement = overallPieChartCanvasElement.getContext('2d');
				
				var overallPieChartOptions = {
					title:{
						fontSize: 14
					},
					legend:{
						labels:{
							boxWidth: 15
						},
						position: "bottom"
					},
					tooltips:{
						enabled: false
					}
				};
				
				
			$s.overallSummaryPieChart.chart = ChartService.getCircleChart(overallPieChartElement, overallPieChartOptions,$s.overallSummaryPieChart.seriesData, $s.overallSummaryPieChart.title);

			
						
			}

			function loadBarCharts(){
				
				// section bar chart 
				_.set($s.sectionBarChart,'title',["Questions that Met Industry Guideline by Evaluation Section"]);

				
			 
				
			var sectionBarChartData = {
					categoryLabels: [],
					seriesData : []

			};
				
				 var metGuidelineQuestionsDataBySection = [];
				 var outsideGuidelineQuestionsDataBySection = [];
				_.forEach($s.sectionsQuestionsAndAnswers,function(section){
					sectionBarChartData.categoryLabels.push(_.get(section,'sectionName',""));		         
				  
					var allMetGuidelineQuestionsWithGuidelines = _.filter(section.metGuidelineQuestions,function(question){ return !_.isUndefined(_.get(question,'QuestionDetailsJson.industryGuideline.compare'));}); 
					var allOutsideGuidelineQuestionsWithGuidelines = _.filter(section.outsideGuidelineQuestions,function(question){ return !_.isUndefined(_.get(question,'QuestionDetailsJson.industryGuideline.compare'));});         

					metGuidelineQuestionsDataBySection.push(allMetGuidelineQuestionsWithGuidelines.length);
					outsideGuidelineQuestionsDataBySection.push(allOutsideGuidelineQuestionsWithGuidelines.length);
				});

	
					
				sectionBarChartData.seriesData.push({
					 label: "Met Guideline",
					 data: metGuidelineQuestionsDataBySection,
					 backgroundColor: _.times(metGuidelineQuestionsDataBySection.length,_.constant("#5C93B4")),
					 borderColor: _.times(metGuidelineQuestionsDataBySection.length,_.constant("#5C93B4")),
					 borderWidth: _.times(metGuidelineQuestionsDataBySection.length,_.constant(1)),
					 hoverBackgroundColor: _.times(metGuidelineQuestionsDataBySection.length,_.constant("#3478A2")),
					 hoverBorderColor: _.times(metGuidelineQuestionsDataBySection.length,_.constant("#3478A2")),
				},{
					label: "Did Not Meet Guideline",
					data: outsideGuidelineQuestionsDataBySection,
					backgroundColor: _.times(outsideGuidelineQuestionsDataBySection.length,_.constant("#EF8666")),
					borderColor: _.times(outsideGuidelineQuestionsDataBySection.length,_.constant("#EF8666")),
					borderWidth: _.times(outsideGuidelineQuestionsDataBySection.length,_.constant(1)),
					hoverBackgroundColor: _.times(outsideGuidelineQuestionsDataBySection.length,_.constant("#EB6841")),
					hoverBorderColor: _.times(outsideGuidelineQuestionsDataBySection.length,_.constant("#EB6841")),
				});

			

				_.set($s.sectionBarChart,'seriesData',sectionBarChartData);

				var sectionStepSize = 5;

				var sectionBarChartOptions = {
					title: {
						display: true,
						fontSize: 14
					},
					legend:{
						labels:{
							boxWidth: 15
						},
						position: "bottom"
						
					},
					scales: {
						xAxes: [{
						   stacked: false,
						   categoryPercentage: 1.0,
						   barPercentage: 0.75,
						   ticks: {
							   autoSkip: false,
							   //max: _.max(_.map(_.map($s.sectionBarChart.seriesData.seriesData,"data"), function(dataArray){ return _.max(dataArray) })) + sectionStepSize,
						   },
						   afterSetDimensions: function(axes) {
							  // console.log("Inside afterSetDimensions");
						    	//console.log(axes);
							//    axes.maxWidth = 165;
							   // console.log(axes.width);
				        	}
							}]
					  },
					tooltips:{
						enabled: false
					}
				};

			   var sectionBarChartCanvasElement = document.getElementById("sectionBarChart");
			   var sectionBarChartElement = sectionBarChartCanvasElement.getContext('2d');
			   $s.sectionBarChart.chart  =  ChartService.getBarChart(sectionBarChartElement,sectionBarChartOptions, $s.sectionBarChart.seriesData, $s.sectionBarChart.title,sectionStepSize);
			  
			   // Question Category Chart

			   _.set($s.categoryBarChart,'title',["Questions that Met Industry Guideline by Category"]);
			 


			   var metGuidelineQuestionsSeriesDataByCategory = [];
			   var outsideGuidelineQuestionsSeriesDataByCategory = [];

			   var allMetGuidelineQuestionsWithGuidelines = _.filter($s.allMetGuidelineQuestions,function(question){ return !_.isUndefined(_.get(question,'QuestionDetailsJson.industryGuideline.compare'));});
			   var allOutsideGuidelineQuestionsWithGuidelines = _.filter($s.allOutsideGuidelineQuestions,function(question){ return !_.isUndefined(_.get(question,'QuestionDetailsJson.industryGuideline.compare'));});         
		 
			 
			   _.forEach($s.codeFileQuestionCategories,function(codeFileCategory){
					 
				var metGuidelineQuestionsByCategory = _.filter(allMetGuidelineQuestionsWithGuidelines,{F360Category: _.get(codeFileCategory,'code')});
				metGuidelineQuestionsSeriesDataByCategory.push(metGuidelineQuestionsByCategory.length);

				var outsideGuidelineQuestionsByCategory = _.filter(allOutsideGuidelineQuestionsWithGuidelines,{F360Category: _.get(codeFileCategory,'code')});
				outsideGuidelineQuestionsSeriesDataByCategory.push(outsideGuidelineQuestionsByCategory.length);
					 
			 });

			 var categoryBarChartData = {
			  categoryLabels: _.map($s.codeFileQuestionCategories,function(codeFileCategory){ return _.get(codeFileCategory,'codeValue');}),
			  seriesData : []

			 };
			   
				 
			   categoryBarChartData.seriesData.push( {
				label: "Met Guideline",
				data: metGuidelineQuestionsSeriesDataByCategory,
				backgroundColor: _.times(metGuidelineQuestionsSeriesDataByCategory.length,_.constant("#5C93B4")),
				borderColor: _.times(metGuidelineQuestionsSeriesDataByCategory.length,_.constant("#5C93B4")),
				borderWidth: _.times(metGuidelineQuestionsSeriesDataByCategory.length,_.constant(1)),
				hoverBackgroundColor: _.times(metGuidelineQuestionsSeriesDataByCategory.length,_.constant("#3478A2")),
				hoverBorderColor: _.times(metGuidelineQuestionsSeriesDataByCategory.length,_.constant("#3478A2")),
		   },{
			   label: "Did Not Meet Guideline",
			   data: outsideGuidelineQuestionsSeriesDataByCategory,
			   backgroundColor: _.times(outsideGuidelineQuestionsSeriesDataByCategory.length,_.constant("#EF8666")),
			   borderColor: _.times(outsideGuidelineQuestionsSeriesDataByCategory.length,_.constant("#EF8666")),
			   borderWidth: _.times(outsideGuidelineQuestionsSeriesDataByCategory.length,_.constant(1)),
			   hoverBackgroundColor: _.times(outsideGuidelineQuestionsSeriesDataByCategory.length,_.constant("#EB6841")),
			   hoverBorderColor: _.times(outsideGuidelineQuestionsSeriesDataByCategory.length,_.constant("#EB6841")),
		   });

		   _.set($s.categoryBarChart,'seriesData',categoryBarChartData);

		  var categoryStepSize = 5;

		   var categoryBarChartOptions = {
			   title: {
				   display: true,
				   fontSize: 14
			   },
			   legend:{
				   labels:{
					   boxWidth: 15
				   },
				   position: "bottom"
				   
			   },
			   scales: {
				xAxes: [{
				   stacked: false,
				   categoryPercentage: 1.0,
				   barPercentage: 0.75,
				   ticks: {
					   autoSkip: false,
					   suggestedMax: 40
					   //max: _.ceil(_.max(_.map(_.map($s.categoryBarChart.seriesData.seriesData,"data"), function(dataArray){ return _.max(dataArray) }))/5)*5 + categoryStepSize,
				   }
					}]
			  },
			   tooltips:{
				   enabled: false
			   }
		   };

		  var categoryBarChartCanvasElement = document.getElementById("categoryBarChart");
		  var categoryBarChartElement = categoryBarChartCanvasElement.getContext('2d');
		  $s.categoryBarChart.chart  =  ChartService.getBarChart(categoryBarChartElement,categoryBarChartOptions, $s.categoryBarChart.seriesData, $s.categoryBarChart.title, categoryStepSize);
		
		  


			}
	
			// function that loads the followup items on load of the results and write report screen
			function loadFollowupItems(){
				
				_.forEach($s.sectionsQuestionsAndAnswers,function(section){
					 
					 _.forEach(section.outsideGuidelineQuestions,function(question){
						 if(_.get(question,'Answer.FollowUp')){
							 $s.followupItems.push(question);
						 }
					 });
	
	
					 _.forEach(section.metGuidelineQuestions,function(question){
						if(_.get(question,'Answer.FollowUp')){
							$s.followupItems.push(question);
						}
					});
	
	
				});
				
			}
			function getMilkingCount(){
				var milkingCnt = "";

				var currentHerd = MSF.getActiveHerd();

				if (!_.isEmpty(currentHerd)) {
					api.getReportDetailsByReportCodeAndHerdId({
						reportCode: 'DASHBOARDCLASSIC',
						herdId: currentHerd.herdId
					}, function reportDetailsGotten(err, reportData) {

                        var breakpoint = "";
					});

				}
				return milkingCnt;
			}
			$s.updateAnswers = function updateAnswers(){
				if($s.syncInProgress === false && $s.updateInProgress === false){
					$s.syncInProgress = true;	
					$s.checkF360SyncStatus().then(function(){
						$s.updateInProgress = true;
						log.info("Review Draft answerUpdate: start");
		
						var AnswerJson = JSON.stringify($s.auditAnswers);
						$s.isDirty = true;
						auditService.updateAnswer(auditId, AnswerJson, function getF360Update (err, data) {
							if (err) {
								log.error('error getting F360 online check: ' + err);
								$s.isDirty = false;
								
							$s.updateInProgress = false;
							$s.syncInProgress = false;
							if($s.finalSaveRequired === true){
								log.info("one more save is required 940");
								$s.finalSaveRequired = false;
								$s.updateAnswers();
							}
							log.info("Review Draft answerUpdate: update of answer failed, update end");
								
							}else{		
								
							// if the update was successfull and we are online we can then the data was synced and we can set isDirty false
							if($s.isOnline){

						
								
								$s.isDirty = false;
								auditService.updateIsDirty(auditId,$s.isDirty,function getIsDirtyUpdate(err, data){
									if (err) {
										log.error('error updateing isDirty flag: ' + err);
									}
							
									auditService.getListByHerdId(function getF360ListByHerdId(err, data) {
									var auditlistItem = _.find(data,{AuditId: auditId});

									log.info("Review Draft answerUpdate: updating last synced date with : ");
									log.info(auditlistItem);

									//if the audit was deleted ,the record won't be in IndexedDB and doesn't need SyncedOn updated
									if(!_.isUndefined(auditlistItem)){ 
										auditService.updateLastSyncedDate(auditId,_.get(auditlistItem,'SyncedOn'),function getUpdateLastSyncDateData(err,data){
											if (err) {
												log.error('error updating server with device data: ' + err);
											}
											$s.updateInProgress = false;
											$s.syncInProgress = false;
											if($s.finalSaveRequired === true){
												log.info("one more save is required 940");
												$s.finalSaveRequired = false;
												$s.updateAnswers();
											}
											log.info("Review Draft answerUpdate: udpated audit sync date after answer update, update end");
										});	 
									}else{
										log.info("Review Draft answerUpdate: could not find audit indexedDB, update end");
										$s.updateInProgress = false;
										$s.syncInProgress = false;
										if($s.finalSaveRequired === true){
											log.info("one more save is required 940");
											$s.finalSaveRequired = false;
											$s.updateAnswers();
										}
									}

								});
							});
							}else{
								auditService.updateIsDirty(auditId,$s.isDirty,function getIsDirtyUpdate(err, data){
									if (err) {
										log.error('error updateing isDirty flag: ' + err);
									}
									
										$s.updateInProgress = false;
										$s.syncInProgress = false;
										if($s.finalSaveRequired === true){
											log.info("one more save is required 940");
											$s.finalSaveRequired = false;
											$s.updateAnswers();
										}
										log.info("Review Draft answerUpdate: offline and updated is dirty flag, update end");
								});
							}
								
							console.log('update ok');
							}
							

						
							
						});
					});
				}else{
					log.info("an answer save attempt was made while another one was going");
					$s.finalSaveRequired = true;
					
				 }
			};

			//function that constructs the display value of a given text value  
			$s.getTextDisplayValue  = function getTextDisplayValue(text){

				// replace any measurement standard text 
				var activeFarmMeasurementStandard = _.get($s.activeFarm,'measurementStandard',"");

				text = MSF.getMeasurementStandardReplacementText(activeFarmMeasurementStandard,text);

				return text;

			};
			// function that formats a questions answer value and returns the formatted value
			$s.formatAnswer = function(question){
			
				var formattedAnswerValue = "";
	
				var questionTemplate = _.get(question,'QuestionTemplate',"");
				var answerValue = _.get(question,'Answer.Value',"");
				var codeType = _.get(question,'CodeType',"");
	
				switch(questionTemplate){
					case "%3,0":
					case "%5,1":
						formattedAnswerValue = answerValue + '%';
					break;
					case "SINGL":
						formattedAnswerValue = _.get(_.find($s.codeFile,{codeType: codeType,code: answerValue}),'codeValue',answerValue); 
					break;
					case "YN":
					   if(answerValue === "Y"){
						   formattedAnswerValue = "Yes";
					   }else if(answerValue === "N"){
						   formattedAnswerValue = "No";
					   } 
					break;
					case "MULTI":
						var valueList = answerValue;
						valueList = valueList.replace(/["()']/g,""); 
						//then we create an array to compare value to 							
						var values = valueList;
						values = valueList.split(',');
						// if the code type for the question was MONTH we need to order the values by calendar order
						if(_.isEqual(question.CodeType,"MONTH")){
						
						 var months = _.filter($s.codeFile,{codeType:"MONTH"});
		
						 values = _.sortBy(values, x => _.findIndex(months, y => _.isEqual(x,y.code))); 
						}
	
						// the values we want to dispaly in the grid is the codeValue(s)(button label) of the code(s)(answer choice) chosen. 
						values = _.map(values,function(value){
							return _.get(_.find($s.codeFile,{code: value}),'codeValue',value); 
						});
						values = values.join(', ');
	
	
						formattedAnswerValue = values;
		
					break;
					default:
					  formattedAnswerValue = answerValue;
	
				}
				return formattedAnswerValue;
			};
			$s.formatIndustryGuideline = function(guideline){
	  
				 var formattedGuideline = "";
				switch(guideline){
					case "---":
					case undefined:{
						formattedGuideline = "N/A";
					break;
					}
					default:
						formattedGuideline = guideline;
					break;	
				}
				return formattedGuideline;
			};

			function formatNextEvaluationDateForServer(date){
			
				var formattedDate = date;
				   
				
				formattedDate = moment(date).format('M/D/YYYY');
			
				return formattedDate;
			}

			$s.updateResultsAndDraft = function updateResultsAndDraft(){
				if($s.syncInProgress === false && $s.updateInProgress === false){
					$s.syncInProgress = true;
					$s.checkF360SyncStatus().then(function(){
						$s.updateInProgress = true;
						log.info("updateResultsAndDraft: start");
						// The next evaluation date should be stored in json field with the pattern "MM/DD/YYYY" , but the NextEvaluationDate field requires a date.
						var reportData = angular.copy($s.report);
						var nextEvaluationDateObject = reportData.resultsWriteRptJson.nextEvaluationDate;
						reportData.resultsWriteRptJson.nextEvaluationDate = formatNextEvaluationDateForServer(reportData.resultsWriteRptJson.nextEvaluationDate);
	
                         var actionItemGroups = _.cloneDeep($s.actionItemGroups);
					
	
						 _.forEach(actionItemGroups,function(actionItemGroup,index,array){
						
							array[index] = _.omit(actionItemGroup,['AssociatedMetricsDisplay','$$hashKey']);
							//array[index] = _.omit(actionItemGroup,'$$hashKey');

							 _.forEach(_.get(actionItemGroup,'ActionItems',[]),function(actionItem,index,array){
								  array[index] = _.omit(actionItem,'$$hashKey');
							 });
						 }); 
	
						_.set(reportData,'reviewDraftRptJson.actionItemGroups',actionItemGroups);


						var draftNotesJson = JSON.stringify(reportData);
						$s.isDirty = true;
						auditService.updateReviewResults(auditId,draftNotesJson,nextEvaluationDateObject,function(data){
						var error = _.get(data,'Error');
						if(error){
							log.error(error);
							$s.isDirty = false;
							$s.updateInProgress = false;
							$s.syncInProgress = false;
							if($s.finalSaveRequired === true){
								log.info("one more save is required 1052");
								$s.finalSaveRequired = false;
								$s.updateResultsAndDraft();
							}
							log.info("updateResultsAndDraft: update failed, update end");
						}else{
	
						
							// if the update was successfull and we are online we can then the data was synced and we can set isDirty false
							if($s.isOnline){
	
											
								$s.isDirty = false;
								auditService.updateIsDirty(auditId,$s.isDirty,function getIsDirtyUpdate(err, data){
									if (err) {
										log.error('error updateing isDirty flag: ' + err);
									}
							
									auditService.getListByHerdId(function getF360ListByHerdId(err, data) {
									var auditlistItem = _.find(data,{AuditId: auditId});
	
									log.info("updateResultsAndDraft: updating last synced date with : ");
									log.info(auditlistItem);
	
									//if the audit was deleted ,the record won't be in IndexedDB and doesn't need SyncedOn updated
									if(!_.isUndefined(auditlistItem)){ 
										auditService.updateLastSyncedDate(auditId,_.get(auditlistItem,'SyncedOn'),function getUpdateLastSyncDateData(err,data){
											if (err) {
												log.error('error updating server with device data: ' + err);
											}
											
											$s.updateInProgress = false;
											$s.syncInProgress = false;
											if($s.finalSaveRequired === true){
												log.info("one more save is required 1086");
												$s.finalSaveRequired = false;
												$s.updateResultsAndDraft();
											}
											log.info("updateResultsAndDraft: udpated audit sync date after answer update, update end");
										});	 
									}else{
										log.info("updateResultsAndDraft: could not find audit indexedDB, update end");
										$s.updateInProgress = false;
										$s.syncInProgress = false;
										if($s.finalSaveRequired === true){
											log.info("one more save is required 1097");
											$s.finalSaveRequired = false;
											$s.updateResultsAndDraft();
										}
										
									}
	
								});
							});
							}else{
								auditService.updateIsDirty(auditId,$s.isDirty,function getIsDirtyUpdate(err, data){
									if (err) {
										log.error('error updateing isDirty flag: ' + err);
									}
									$s.updateInProgress = false;
									$s.syncInProgress = false;
									if($s.finalSaveRequired === true){
										log.info("one more save is required 1114");
										$s.finalSaveRequired = false;
										$s.updateResultsAndDraft();
									}
									log.info("updateResultsAndDraft: offline and updated IsDirty flag, update end");
								});
							}
						
						}     
	
						});
					});
				}else{
				   log.info("an answer save attempt was made while another one was going");
				   $s.finalSaveRequired = true;
				   
				}
			}; 

			$s.onAddActionItemGroup = function onAddActionItemGroup(){
				console.log("add Profit Driver");

				$s.currentActionItemGroup = _.cloneDeep($s.actionItemGroupTmpl);

				_.set($s.currentActionItemGroup,'HerdId',_.get($s.currentHerd,'herdId'));
				_.set($s.currentActionItemGroup,'AuditId',self.auditId);

				$s.isEditingActionItemGroup = false;
				$s.toggleModal("actionItemGroupModal");
			};

			$s.onEditActionItemGroup = function onEditActionItemGroup(actionItemGroup){
				console.log("Edit Profit Driver");
                console.log(actionItemGroup);
                $s.currentActionItemGroupRef = actionItemGroup;

				$s.currentActionItemGroup = _.cloneDeep(actionItemGroup);

                // if(!_.includes(_.pluck($s.codeFileActionItemGroups,'codeValue'),_.get(actionItemGroup,'ActionItemGroupKey'))){
				// 	_.set($s.currentActionItemGroup,'ActionItemGroupKeyFreeText',_.get(actionItemGroup,'ActionItemGroupKey'));
				// 	_.set($s.currentActionItemGroup,'ActionItemGroupKey',_.get(_.find($s.codeFileActionItemGroups,{code:"OTHER"}),'codeValue'));

				// }

				if(_.isEqual(_.get(actionItemGroup,'ActionItemGroupKey'),"OTHER")){
					_.set($s.currentActionItemGroup,'ActionItemGroupKeyFreeText',_.get(actionItemGroup,'Description'));
				}

               
                $s.isEditingActionItemGroup = true;
                // if ($s.currentActionItemGroup.actionItemGroupKey == "Other") {
                //     $("#actionItemGroupModalContent").addClass("modal-farm-management-add-actionitemgroup-tall").removeClass("modal-farm-management-add-actionitemgroup-short");
                // } else {
                //     $("#actionItemGroupModalContent").addClass("modal-farm-management-add-actionitemgroup-short").removeClass("modal-farm-management-add-actionitemgroup-tall");
                // }
               
                // _.set($s.currentActionItemGroup,'AssociatedMetrics',_.map(_.get($s.currentActionItemGroup,'AssociatedMetrics'),function(metric){
				// 														 return {code:_.get(metric,'Metric') , codeValue: _.get(_.find($s.codeFileActionItemGroupMetrics,{code:_.get(metric,'Metric')}),'codeValue')};
				//                                                      })
                //      );

					 _.set($s.currentActionItemGroup,'AssociatedMetrics',_.map(_.get($s.currentActionItemGroup,'AssociatedMetrics'),function(metric){
																			return _.get(metric,'Metric');
																		})
                     );


                $s.toggleModal("actionItemGroupModal");
			};

			$s.onEditActionItem = function onEditActionItem(actionItem,actionItemGroup){
				console.log("Edit Action Item");
				console.log(actionItem);

				$s.isEditingActionItem = true;
				$s.currentActionItem = _.cloneDeep(actionItem);
             
				_.set($s.currentActionItem,'Person',{
													  FarmId: 	    _.get($s.currentActionItem,'FarmId'),
					 								  PersonId: 	_.get($s.currentActionItem,'PersonId'),
													  FirstName: 	_.get($s.currentActionItem,'FirstName'),
													  LastName: 	_.get($s.currentActionItem,'LastName'),
													  FullName: 	_.get($s.currentActionItem,'FullName')

													});

                 _.set($s.currentActionItem,'DueDate', moment(_.get($s.currentActionItem,'DueDate')).toDate());													



				$s.currentActionItemRef = actionItem;
				$s.currentActionItemGroupRef = actionItemGroup;
				$s.toggleModal("actionItemModal");
			};

			$s.onAddActionItem = function onAddActionItem(actionItemGroup) {
				console.log(actionItemGroup);

				$s.currentActionItem = _.cloneDeep($s.actionItemTmpl);
				_.set($s.currentActionItem,'Status',"NS");
				_.set($s.currentActionItem,'AuditId',self.auditId);

				$s.currentActionItemGroupRef = actionItemGroup;
				$s.isEditingActionItem = false;

				console.log("Add Action Item to "+_.get(actionItemGroup,'ActionItemGroupKey'));
				
				$s.toggleModal("actionItemModal");
			};


			$s.onSave = function onSave(actionDataType, modalId) {
				switch (actionDataType) {
					case "ACTION_ITEM_GROUP":
						var validationErrors = $s.validateActionItemGroup($s.currentActionItemGroup);
						if(_.isEmpty(validationErrors)){
                              
							// if(_.isEqual(_.get($s.currentActionItemGroup,'ActionItemGroupKey'),_.get(_.find($s.codeFileActionItemGroups,{code:"OTHER"}),'codeValue'))){
							// 	_.set($s.currentActionItemGroup,'ActionItemGroupKey',_.get($s.currentActionItemGroup,'ActionItemGroupKeyFreeText'));
					        //     $s.currentActionItemGroup = _.omit($s.currentActionItemGroup,'ActionItemGroupKeyFreeText');  
							// }

							if(_.isEqual(_.get($s.currentActionItemGroup,'ActionItemGroupKey'),"OTHER")){
								_.set($s.currentActionItemGroup,'Description',_.get($s.currentActionItemGroup,'ActionItemGroupKeyFreeText'));
							}else{
								_.set($s.currentActionItemGroup,'Description',_.get(_.find($s.codeFileActionItemGroups,{code: _.get($s.currentActionItemGroup,'ActionItemGroupKey')} ),'codeValue'));
							}
							$s.currentActionItemGroup = _.omit($s.currentActionItemGroup,'ActionItemGroupKeyFreeText');  
					        
							if(_.get(_.get($s.currentActionItemGroup,'AssociatedMetrics'),'length') > 0){
								_.set($s.currentActionItemGroup,'AssociatedMetrics',_.map(_.get($s.currentActionItemGroup,'AssociatedMetrics'),function(metricCode){
																						return {Metric: metricCode};
																					})

                                );
							}
							_.set($s.currentActionItemGroup,'AssociatedMetricsDisplay', $s.getAssociatedMetricsStringList(_.get($s.currentActionItemGroup,'AssociatedMetrics',[]),"Metric",","));
							
							
							
							if ($s.isEditingActionItemGroup) {

						    

							// update existing group 

							

							//var existingGroup = _.find($s.actionItemGroups,{ActionItemGroupKey: _.get($s.currentActionItemGroupRef,'ActionItemGroupKey')});
                            _.forEach($s.actionItemGroups,function(actionItemGroup,index,array){
                                   if(_.isEqual(_.get(actionItemGroup,'$$hashKey'),_.get($s.currentActionItemGroupRef,'$$hashKey'))){

									   array[index] = _.cloneDeep($s.currentActionItemGroup);
								   }
							});

							

							} else {
								$s.actionItemGroups.push($s.currentActionItemGroup);
							}

							$s.isEditingActionItemGroup = false;
							$s.currentActionItemGroup = {};
							$s.currentActionItemGroupRef = {};
							$s.toggleModal(modalId);
							$s.clearAllActionItemGroupValidationErrors();
							$s.updateResultsAndDraft();
						}else{
							_.forEach(validationErrors,function(error){
								var controlId = _.get(error,'controlId');
								var controlErrorTextId = _.get(error,'controlErrorTextId');
								$(controlId).addClass('error'); 
								$(controlErrorTextId).removeClass('dis-none');       
							});
						}
						break;
					case "ACTION_ITEM":
						console.log($s.currentActionItem);
						console.log($s.currentActionItemGroup);

						var validationErrors = $s.validateActionItem($s.currentActionItem,$s.currentActionItemGroupRef);
						if(_.isEmpty(validationErrors)){

							// flatten Person object and remove the property
                            _.set($s.currentActionItem,'PersonId',_.get($s.currentActionItem,'Person.PersonId'));
							_.set($s.currentActionItem,'FirstName',_.get($s.currentActionItem,'Person.FirstName'));
							_.set($s.currentActionItem,'LastName',_.get($s.currentActionItem,'Person.LastName'));
							_.set($s.currentActionItem,'FullName',_.get($s.currentActionItem,'Person.FullName'));

							$s.currentActionItem = _.omit($s.currentActionItem,'Person');

							_.set($s.currentActionItem,'DueDate', moment(_.get($s.currentActionItem,'DueDate')).format('M/D/YYYY'));


							if ($s.isEditingActionItem) {

						    

								// update existing item 
	
								
	
								//var existingGroup = _.find($s.actionItemGroups,{ActionItemGroupKey: _.get($s.currentActionItemGroupRef,'ActionItemGroupKey')});
								_.forEach(_.get($s.currentActionItemGroupRef,'ActionItems',[]),function(actionItem,index,array){
									   if(_.isEqual(_.get(actionItem,'$$hashKey'),_.get($s.currentActionItemRef,'$$hashKey'))){
	
										   array[index] = _.cloneDeep($s.currentActionItem);
									   }
								});
	
								
	
								} else {
									_.get($s.currentActionItemGroupRef,'ActionItems',[]).push($s.currentActionItem);
								}
	
								
							

							$s.isEditingActionItem = false;
							$s.currentActionItem = {};
							$s.currentActionItemRef = {};
							$s.currentActionItemGroupRef = {};
							$s.toggleModal(modalId);
							$s.clearAllActionItemValidationErrors();
							$s.updateResultsAndDraft();
						}else{
							_.forEach(validationErrors,function(error){
								var controlId = _.get(error,'controlId');
								var controlErrorTextId = _.get(error,'controlErrorTextId');
								$(controlId).addClass('error'); 
								$(controlErrorTextId).removeClass('dis-none');       
							});
						}
						break;
					default:
						break;
				}
				
			};

			$s.onCancel = function onCancel(actionDataType, modalId) {
				switch (actionDataType) {
					case "ACTION_ITEM_GROUP":
						$s.isEditingActionItemGroup = false;
						$s.currentActionItemGroup = {};
						$s.currentActionItemGroupRef = {};
						$s.clearAllActionItemGroupValidationErrors();
						break;
					case "ACTION_ITEM":
						$s.isEditingActionItem = false;
						$s.currentActionItem = {};
						$s.currentActionItemRef = {};
						$s.currentActionItemGroupRef = {};
						$s.clearAllActionItemValidationErrors();
						break;
					default:
						break;
				}
				$s.toggleModal(modalId);
			};

			$s.onDelete = function onDelete(actionDataType, modalId) {
				switch (actionDataType) {
					case "ACTION_ITEM_GROUP":


					    

						//var existingGroup = _.find($s.actionItemGroups,{ActionItemGroupKey: _.get($s.currentActionItemGroupRef,'ActionItemGroupKey')});
						
						MSF.confirm({
							title: 'Remove',
							messageHeader: "Profit Driver: "+_.get($s.currentActionItemGroup,'Description',""),
							message: "Are you sure you want to remove this Profit Driver? Removing the Profit Driver will remove all Action Items under it.",
							confirm: {
								className: 'danger',
								icon: 'trash',
								text: "Remove"
							}
					  }, function confirmActionItemGroupRemoval(){
					  
						$s.$applyAsync($s.actionItemGroups = _.reject($s.actionItemGroups,$s.currentActionItemGroupRef));	
						
						$s.isEditingActionItemGroup = false;
						$s.currentActionItemGroup = {};
						$s.currentActionItemGroupRef = {};

						$s.toggleModal(modalId);
						$s.updateResultsAndDraft();
	  
					  },function cancelActionItemGroupRemoval(){
						  
						   log.info("The ActionItemGroup removal was canceled");
					  });
					  
						break;
					case "ACTION_ITEM":

					
						var existingActionItem = _.find(_.get($s.currentActionItemGroupRef,'ActionItems',[]),{Description: _.get($s.currentActionItemRef,'Description')});
					
						MSF.confirm({
							title: 'Remove',
							messageHeader: "Action Item: "+_.get(existingActionItem,"Description",""),
							message: "Are you sure you want to remove this Action Item?",
							confirm: {
								className: 'danger',
								icon: 'trash',
								text: "Remove"
							}
					  }, function confirmActionItemRemoval(){
					  
						var actionItemGroupActionItems = _.get($s.currentActionItemGroupRef,'ActionItems',[]);

						_.forEach($s.actionItemGroups,function(actionItemGroup){
                             if(_.isEqual(_.get(actionItemGroup,'Description'),_.get($s.currentActionItemGroupRef,'Description'))){
								
								$s.$applyAsync(actionItemGroup.ActionItems = _.reject(actionItemGroup.ActionItems,$s.currentActionItemRef));
								
								//   _.forEach(_.get(actionItemGroup,'ActionItems',[]),function(actionItem,index,array){
                                //           if(_.isEqual(_.get(actionItem,'Description'),_.get($s.currentActionItem,'Description'))){

								// 		  }
								//   });
							 }
						});

						//$s.$applyAsync($s.actionItemGroups.ActionItems = _.reject($s.actionItemGroups,existingGroup));	
						
						$s.isEditingActionItem = false;
						$s.currentActionItem = {};
						$s.currentActionItemRef = {};
						$s.currentActionItemGroupRef = {};

						$s.toggleModal(modalId);
						$s.updateResultsAndDraft();
	  
					  },function cancelActionItemRemoval(){
						  
						   log.info("The ActionItem removal was canceled");
					  });
					
						break;
					default:
						break;
				}
				
			};
			$s.clearAllActionItemGroupValidationErrors = function clearAllActionItemGroupValidationErrors(){
				$("#modalActionItemGroupKey").removeClass('error');
				$("#errorInputActionItemGroupKey").addClass('dis-none');

				$("#modalActionItemGroupKeyFreeText").removeClass('error');
				$("#errorInputActionItemGroupKeyFreeText").addClass('dis-none');
				
				$("#modalActionItemGroupAssociatedMetric").removeClass('error');
				$("#errorInputAssociatedMetricText").addClass('dis-none');

				$s.actionItemGroupKeyErrorText = "";
				$s.actionItemGroupKeyFreeTextErrorText = "";
				
				
			};

			$s.clearAllActionItemValidationErrors = function clearAllActionItemValidationErrors(){
				$("#modalActionItemDescription").removeClass('error');
				$("#errorInputDescriptionText").addClass('dis-none');

				$("#modalActionItemAssignedTo").removeClass('error');
				$("#errorInputAssignedToText").addClass('dis-none');
				
				$("#modalActionItemDueDate").removeClass('error');
				$("#errorInputDueDateText").addClass('dis-none');

				$s.actionItemGroupKeyErrorText = "";
				$s.actionItemGroupKeyFreeTextErrorText = "";
				
				
			};

			$s.validateActionItem = function validateActionItem(actionItem,actionItemGroup){
				var invalidErrorIds = [];

				
                //--------------------------------------------------------------
				// Description(What To Do) Validation
			    //--------------------------------------------------------------
				var descriptionControlId = "#modalActionItemDescription";
				var descriptionErrorTextId = "#errorInputDescriptionText";
				var description = _.trim(_.get(actionItem,'Description'));
                  
				if(_.isEmpty(description)){
					invalidErrorIds.push({controlId: descriptionControlId,controlErrorTextId: descriptionErrorTextId});
				}
				//--------------------------------------------------------------

				//--------------------------------------------------------------
				// AssignedTo Validation
			    //--------------------------------------------------------------
				 var assignedToControlId = "#modalActionItemAssignedTo";
				 var assignedToErrorTextId = "#errorInputAssignedToText";
				 var assignedTo = _.get(actionItem,'Person',{});

				 if(_.isEmpty(assignedTo)){
					invalidErrorIds.push({controlId: assignedToControlId,controlErrorTextId: assignedToErrorTextId});
				 }
                    
				//--------------------------------------------------------------


				//--------------------------------------------------------------
				// DueDate Validation
			    //--------------------------------------------------------------
				 
				var dueDateControlId = "#modalActionItemDueDate";
				var dueDateErrorTextId = "#errorInputDueDateText";
				var dueDate = _.get(actionItem,'DueDate');

				if(_.isUndefined(dueDate) || _.isEqual(dueDate,"") || moment(dueDate).toDate() <= moment().toDate()){
				   invalidErrorIds.push({controlId: dueDateControlId,controlErrorTextId: dueDateErrorTextId});
				}
				
				//--------------------------------------------------------------

				return invalidErrorIds;
			};

			$s.validateActionItemGroup = function validActionItemGroup(actionItemGroup){
				var invalidErrorIds = [];

				
                //--------------------------------------------------------------
				// Group Key Validation
			    //--------------------------------------------------------------
				var isFreeTextGroupKey = false;
				var groupKeyInputId = "#modalActionItemGroupKey";
				var groupKeyErrorTextId = "#errorInputActionItemGroupKey";
				var chosenGroupKey = _.get(actionItemGroup,'ActionItemGroupKey');
				 
				if(_.isEqual(chosenGroupKey,"OTHER")){
					chosenGroupKey = _.get(actionItemGroup,'ActionItemGroupKeyFreeText');
					groupKeyInputId = "#modalActionItemGroupKeyFreeText";
					groupKeyErrorTextId = "#errorInputActionItemGroupKeyFreeText";
					var isFreeTextGroupKey = true;
				} 
                var refGroupKey = _.get($s.currentActionItemGroupRef,'ActionItemGroupKey');
			
                 // no group key was chosen
                if(_.isEmpty(chosenGroupKey)){
					if(isFreeTextGroupKey){
						$s.actionItemGroupKeyFreeTextErrorText = "Required field.";
					}else{
						$s.actionItemGroupKeyErrorText = "Required field.";
					}
					
					invalidErrorIds.push({controlId: groupKeyInputId,controlErrorTextId: groupKeyErrorTextId});
				}

			    chosenGroupKey = _.trim(chosenGroupKey);

				var existingGroupKeys = _.pluck($s.actionItemGroups,'ActionItemGroupKey');

				   
				if(!_.includes(_.pluck(invalidErrorIds,'controlId'),groupKeyInputId) 
				   && (
					         (!$s.isEditingActionItemGroup && _.includes(existingGroupKeys,chosenGroupKey)) // user is trying to add a new group with a duplicate key
						  || ($s.isEditingActionItemGroup && !_.isEqual(refGroupKey,chosenGroupKey) && _.includes(existingGroupKeys,chosenGroupKey)) // user is editing a group and changed the group key to one that already exists 
					  )
					  
				  ){
					if(isFreeTextGroupKey){
						$s.actionItemGroupKeyFreeTextErrorText = "The profit driver cannot be duplicated.";
					}else{
						$s.actionItemGroupKeyErrorText = "The profit driver cannot be duplicated.";
					}
					invalidErrorIds.push({controlId: groupKeyInputId,controlErrorTextId: groupKeyErrorTextId});
				}
			   //--------------------------------------------------------------

			   //--------------------------------------------------------------
			   // Associated Metrics
			   //--------------------------------------------------------------

                var associatedMetricsControlId = "#modalActionItemGroupAssociatedMetric";
				var associatedMetricsErrorTextId = "#errorInputAssociatedMetricText";

				var associatedMetrics = _.get(actionItemGroup,'AssociatedMetrics',[]);
				if(_.isEqual(_.get(associatedMetrics,'length'),0)){
					invalidErrorIds.push({controlId: associatedMetricsControlId,controlErrorTextId: associatedMetricsErrorTextId});
				}

			   //--------------------------------------------------------------

//_.pluck(_.filter($s.actionItemGroups,{ActionItemGroupKey:chosenGroupKey}) ,'ActionItemGroupKey')
				return invalidErrorIds;
			};

			


			$s.onActionItemGroupKeyChange = function onActionItemGroupKeyChange() {
                console.log("test");
                console.log($s.currentActionItemGroup.actionItemGroupKey);
                var hadError = $("#modalActionItemGroupKey").hasClass("error");

				if(hadError){
					$("#modalActionItemGroupKey").removeClass('error');
					$("#errorInputActionItemGroupKey").addClass('dis-none');
				}

                // if ($s.currentActionItemGroup.actionItemGroupKey == "Other") {
                //     $("#actionItemGroupModalContent").addClass("modal-farm-management-add-actionitemgroup-tall").removeClass("modal-farm-management-add-actionitemgroup-short");
                // } else {
                //     $("#actionItemGroupModalContent").addClass("modal-farm-management-add-actionitemgroup-short").removeClass("modal-farm-management-add-actionitemgroup-tall");
                // }
                return true;
            };

			$s.onActionItemGroupKeyFreeTextChange = function onActionItemGroupKeyFreeTextChange(){
				var hadError = $("#modalActionItemGroupKeyFreeText").hasClass("error");

				if(hadError){
					$("#modalActionItemGroupKeyFreeText").removeClass('error');
					$("#errorInputActionItemGroupKeyFreeText").addClass('dis-none');
				}
			};
			$s.onActionItemGroupAssociatedMetricsChange = function onActionItemGroupAssociatedMetricsChange(){
				var hadError = $("#modalActionItemGroupAssociatedMetric").hasClass("error");

				if(hadError){
					$("#modalActionItemGroupAssociatedMetric").removeClass('error');
					$("#errorInputAssociatedMetricText").addClass('dis-none');

				}
			};

			$s.onActionItemDescriptionChange = function onActionItemDescriptionChange(){
				var hadError = $("#modalActionItemDescription").hasClass("error");

				if(hadError){
					$("#modalActionItemDescription").removeClass('error');
					$("#errorInputDescriptionText").addClass('dis-none');

				}
			};

			$s.onAssignedToChange = function (val) {
				var hadError = $("#modalActionItemAssignedTo").hasClass("error");

				if(hadError){
					$("#modalActionItemAssignedTo").removeClass('error');
					$("#errorInputAssignedToText").addClass('dis-none');
				}
			}

			
			$s.onDueDateChange = function onDueDateChange() {
				var hadError = $("#modalActionItemDueDate").hasClass("error");

				if(hadError){
					$("#modalActionItemDueDate").removeClass('error');
					$("#errorInputDueDateText").addClass('dis-none');
				}
			};

			$s.toggleModal = function (modalId) {
				var modal = $('#' + modalId);
				if (!modal) return;

				if (modal.is(':visible')) {
					modal.css("display", "none");
				} else {
					modal.css("display", "block");
				}
			}

			$s.toggleField = function toggleField(hideObj, showObj) {
				hideObj.disabled = true;
				hideObj.style.display = 'none';
				showObj.disabled = false;
				showObj.style.display = 'inline';
				showObj.focus();
			}

			// $s.onManagementAcceptedChange = function onManagementAcceptedChange(followupItem){
			// 	var followupItemMgtAccepted = _.get(followupItem,'Answer.MgmtAccepted');

			// 	 if(_.isEqual(followupItemMgtAccepted,true)){
            //         _.set(followupItem,'Answer.Status', "NOTSTART");
			// 	 }else{
			// 		_.set(followupItem,'Answer.Status', "DECLINED");
					
			// 	 }
			// 	 $s.validateTargetDate(followupItem);
			// 	 var auditAnswer = _.find($s.auditAnswers,{"QuestionId":followupItem.QuestionId});
			// 		 auditAnswer.AnswerDetailsJson = angular.copy(followupItem.Answer); 

			// 	// we need to convert answer date fields to a string format before saving. 
			// 	_.set(auditAnswer,'AnswerDetailsJson.TargetDate',formatDateString(_.get(followupItem,'Answer.TargetDate',null))); 
			// 	 $s.updateAnswers();
			// };


			// $s.onFollowupItemTargetDateChange = function onFollowupItemStatusChange(followupItem){
				
			// 	if($s.validateTargetDate(followupItem)){
			// 		var auditAnswer = _.find($s.auditAnswers,{"QuestionId":followupItem.QuestionId});
			// 			auditAnswer.AnswerDetailsJson = angular.copy(followupItem.Answer); 

			// 		// we need to convert answer date fields to a string format before saving. 
			// 		_.set(auditAnswer,'AnswerDetailsJson.TargetDate',formatDateString(_.get(followupItem,'Answer.TargetDate',null))); 
			// 		$s.updateAnswers();
			// 	}
				
			// } 
			$s.onReviewedReportChange = function onReviewedReportChange(){
				$s.checkF360SyncStatus();
			}
			// $s.validateTargetDate = function(question){
			// 	var validTargetDate = false;
            //       if(_.isEqual(_.get(question,'Answer.MgmtAccepted'),true)){
			// 		  var targetDate = _.get(question,'Answer.TargetDate',null);
			// 		   // the target date is required if MgmtAccepted is true and cannot be in the past
			// 		  if((!_.isNull(targetDate)) && (targetDate >= $s.minTargetDate)){
			// 			  validTargetDate = true;
			// 		  }
					
			// 	  }else{
			// 		validTargetDate = true;
			// 	  }

			// 	return validTargetDate;
			// }
		  
			// $s.validateReviewedReport = function validateReviewedReport(){
			// 	var validateReviewedReport = true;
				
			// 	if(!$s.report.reviewDraftRptJson.reviewedReport){
			// 		validateReviewedReport = false;

			// 		$("#reviewedReportCheckmark").addClass('error-container');
			// 		$(".review-draft-report-review-report-checkbox-error-text").removeClass('dis-none');
			// 	}else{
			// 		$("#reviewedReportCheckmark").removeClass('error-container');
			// 		$(".review-draft-report-review-report-checkbox-error-text").addClass('dis-none');
			// 	}

			// 	return validateReviewedReport;
				
			// }  
		   

			$s.validate = function validate(){
			var validActionItemGroups = true;
			var validActionItems = true;

             if(_.get($s.actionItemGroups,'length') == 0){
				$s.currentTopAnchor = "actionItemGroupSection";
                validActionItemGroups = false;
			 }

			 var allActionItems = _.pluck($s.actionItemGroups,'ActionItems');
			 var anActionItemExists = false;
			     anActionItemExists = _.all(allActionItems,function(actionItemArray){
                                                   if(_.get(actionItemArray,'length') > 0){
													   return true;
												   }
			                                  });
			 if(!anActionItemExists){
				$s.currentTopAnchor = "actionItemGroupSection";
				validActionItems = false;
			 }



			// 	_.forEach($s.followupItems,function(question){
				  
			// 		if(!$s.validateTargetDate(question)){
			// 			validTargetDates = false;
					   
			// 			$s.currentTopAnchor = "targetDate"+question.QuestionId;
					   
			// 		   return false;	
			// 		}
					
			// 	});


			// 	 validReviewedReport = $s.validateReviewedReport();

			 	return validActionItemGroups && validActionItems;
            // return true;
				
			}

			$s.publishActionItemGroups = function publishActionItemGroups(actionItemGroups){

				var actionItemGroupsData = _.cloneDeep(actionItemGroups);
                  
                _.forEach(actionItemGroupsData,function(actionItemGroup,index,groupArray){
                    
                       _.set(actionItemGroup,'HerdId',_.get($s.currentHerd,'herdId'));
					   _.set(actionItemGroup,'AuditId',self.auditId);
					   _.set(actionItemGroup,'GroupDesc',_.get(actionItemGroup,'Description'));
					   _.set(actionItemGroup,'ActionItemJson',_.get(actionItemGroup,'ActionItems'))  
                      
					   actionItemGroup = _.omit(actionItemGroup,["Description","ActionItems"]);

					   groupArray[index] = _.cloneDeep(actionItemGroup);

				});

				//var breakpoint = "";

				api.publishActionItemGroupDetails(self.auditId,JSON.stringify(actionItemGroupsData),function(data){
					   var error = _.get(data,'Error');
					   if(error){
				    	  log.error(error);

					   }
				});



			}

			$s.publishReport = function(){

                if($s.validate()){
				
					 $s.updateInProgress = true;
					log.info("publishReport: start");
					$s.currentTopAnchor = "";
					
					// actual redirect for this report
					//href="#/f360"
					
					var reportData = angular.copy($s.report);

					_.set(reportData,'reviewDraftRptJson.reportDate', moment().format()); 
                    
					//var nextEvaluationDateObject = reportData.resultsWriteRptJson.nextEvaluationDate;
					//reportData.resultsWriteRptJson.nextEvaluationDate = formatDateString(reportData.resultsWriteRptJson.nextEvaluationDate);
					var actionItemGroups = _.cloneDeep($s.actionItemGroups);

					_.forEach(actionItemGroups,function(actionItemGroup,index,array){
						
						array[index] = _.omit(actionItemGroup,['AssociatedMetricsDisplay','$$hashKey']);
						//array[index] = _.omit(actionItemGroup,'$$hashKey');

						 _.forEach(_.get(actionItemGroup,'ActionItems',[]),function(actionItem,index,array){
							  array[index] = _.omit(actionItem,'$$hashKey');
						 });
					 }); 

					 $s.publishActionItemGroups(actionItemGroups);

					_.set(reportData,'reviewDraftRptJson.actionItemGroups',actionItemGroups);
	
					var draftNotesJson = JSON.stringify(reportData);

					$s.isDirty = true;
					auditService.publishAudit(auditId,draftNotesJson,function(data){
					   var error = _.get(data,'Error');
					   if(error){
				    	  log.error(error);
						  $s.isDirty = false;
						  $s.updateInProgress = false;
						  log("publishReport: failed to publish report , update end");
			     	   }else{
				 		  // if the update was successfull and we are online we can then the data was synced and we can set isDirty false
				  if($s.isOnline){

		
					
					$s.isDirty = false;
					auditService.updateIsDirty(auditId,$s.isDirty,function getIsDirtyUpdate(err, data){
						if (err) {
							log.error('error updateing isDirty flag: ' + err);
						}
				
						auditService.getListByHerdId(function getF360ListByHerdId(err, data) {
						var auditlistItem = _.find(data,{AuditId: auditId});

						 log.info("publishReport: updating last synced date with : ");
						log.info(auditlistItem);

						 //if the audit was deleted ,the record won't be in IndexedDB and doesn't need SyncedOn updated
						if(!_.isUndefined(auditlistItem)){ 
							auditService.updateLastSyncedDate(auditId,_.get(auditlistItem,'SyncedOn'),function getUpdateLastSyncDateData(err,data){
								if (err) {
									log.error('error updating server with device data: ' + err);
								}
								$s.updateInProgress = false;
								log.info("publishReport: updated audit sync date after audit publish, update end");
								$window.location.href = "#/f360";
							});	 
						}else{
							log.info("publishReport: could not find audit indexedDB , update end");
							$s.updateInProgress = false;
						
						}

					});
				  });
				}else{
					auditService.updateIsDirty(auditId,$s.isDirty,function getIsDirtyUpdate(err, data){
						if (err) {
							log.error('error updateing isDirty flag: ' + err);
						}
						$s.updateInProgress = false;
						log.info("publishReport: offline and updated is dirty  flag , update end");
						$window.location.href = "#/f360";
					});
				}			
			   }  
					});
					
				}else{
					if(!_.isEqual($s.currentTopAnchor,"")){
						$s.scrollToTopError();
					 }
				}

			}
			$s.scrollToTopError = function(){
				var topErrorElem = $("#"+$s.currentTopAnchor);
				var container = $("#review-draft-report");
				if(!_.isUndefined(topErrorElem)){
					$window.scrollTo(0,topErrorElem.offset().top - container.offset().top + container.scrollTop());
				}
			}

			$s.addQuestionCategories = function(){
				//test interval 22
				var firstIntervalStartIndex = 2;
				var secondIntervalStartIndex = 25;
				var thirdIntervalStartIndex = 48;
				var fourthIntervalStartIndex = 71;
				var fifthIntervalStartIndex = 94;
				var sixthIntervalStartIndex = 117;
	
				_.forEach($s.auditQuestions,function(question){
					switch(true){
						case  (question.QuestionId >= 2 && question.QuestionId < 25):
						  _.set(question,'category','Cow Comfort');
						break;
						case (question.QuestionId >= 25 && question.QuestionId < 48):
							_.set(question,'category','Data Quality');
							break;
						case (question.QuestionId >= 48 && question.QuestionId < 71):
							_.set(question,'category','Fertility');
							break;
						case (question.QuestionId >= 71 && question.QuestionId < 94):
							_.set(question,'category','Nutrition');
							break;		
						case (question.QuestionId >= 94 && question.QuestionId < 117):
							_.set(question,'category','Personnel');
							break;
						case (question.QuestionId >= 117 && question.QuestionId < 140):
							_.set(question,'category','Transition Cow');
							break;
						case (question.QuestionId >= 141):
							_.set(question,'category','Unassigned');
							break;		
	
					}
				});
				
			}

		function loadActionItemGroupsAndItems(){
             _.set(testActionItemGroup,'associatedMetrics',
			     _.pluck(testAssociatedMetrics,'name').join(",") 	
			);

			 _.set(testActionItemGroup,'actionItems',testActionItems);
		
			 $s.actionItemGroups.push(testActionItemGroup);

			 var testActionItemGroup2 = _.cloneDeep(testActionItemGroup);

			 _.set(testActionItemGroup2,'actionItemGroupKey',"Cow Comfort");

			$s.actionItemGroups.push(testActionItemGroup2);

			$s.people = _.cloneDeep(testPeople);
		}	

		function loadReportData(){
			auditService.getIndexedDBReviewResultsAndDraft(self.auditId, function getIndexedDBReviewResultsAndDraft(err, data) {
				if (err) {
					log.error('error getting F360 Review Results And Draft Data: ' + err);
					MSF.confirmation.danger(err,false);
				}
	
				if (data && data.length) {
					//var reportData = {};
					try{
					  $s.reportData =	JSON.parse(data);
					}catch(e){
						console.log("failed to parse report date");
					}
	
					if (!window.navigator.onLine) {
						$s.$apply();
					}
				}
	
					 auditService.getIndexedDBOverViewList(self.auditId, function getIndexedDBOverViewList(err, data) {
						if (err) {
							log.error('error getting F360 Over View List: ' + err);
							MSF.confirmation.danger(err,false);
						}
						if (data && data.length) {
							$s.overViewList = data;
							for (let index = 0; index < $s.overViewList.length; index++) {
								$s.overViewList[index].AnswerCnt = 0;
								$s.overViewList[index].QuestionCnt = 0;
							}
							if (!window.navigator.onLine) {
								$s.$apply();
							}
						}
	
							auditService.getIndexedDBQuestionList(auditId, function getIndexedDBQuestionList(err, data) {
							if (err) {
								log.error('error getting F360 Over View List: ' + err);
								MSF.confirmation.danger(err,false);
							}
							
							if (data && data.length) {
								var arrQuestion = [];
								var parseDataQuestion = JSON.parse(data);
								var questionDetailsJson = parseDataQuestion.QuestionsJson;
							
								for (let i = 0; i < questionDetailsJson.length; i++) {
									arrQuestion.push(questionDetailsJson[i].QuestionJson[0]);
								}
								// we need to order the questions here in the ux because the questions come from a JSON field
								// intead their own records in a table.
								$s.auditQuestions = _.sortByOrder(arrQuestion,['SortOrder'],['asc']);

							


								auditService.getIndexedDBAnswerList(auditId, function getIndexedDBAnswerList(err, data) {
									if (err) {
										console.log('error getting F360 Over View List: ' + err);
										MSF.confirmation.danger(err,false);
									} 
									if (data && data.length) {
										try{
										 $s.auditAnswers = JSON.parse(data);
										}catch(e){
										  log.error("failed to parse answer list json : "+_.get(e,'message'," "));
										}
									 
									 
									 } else {
										$s.auditAnswers = [];
									 }

								    //if the not applicable question is checked we have to exclude certain questions including the NA question itself. 
								    removeExcludedQuestions();
	
									$s.$applyAsync(function(){
										buildSectionsQuestionsAndAnswers();
										loadPieCharts();
										loadBarCharts();
										loadFollowupItems();
										buildReportData();
										//loadActionItemGroupsAndItems();
									});
	
								});
	
							} 
						});
					});
				});
			}

		

			$s.syncingBackOnline = false;
		   
			deregOnlineCheckWatch =	$s.$on('online:change',function(event,onLineChange){
			 
					var onLineValue = _.get(onLineChange,'value');
					var isOnlineOldValue =  angular.copy($s.isOnline);
					$s.isOnline = onLineValue; 
					// if the device was previously offline and now back online
				 // we need to see if we will run checkF360SyncStatus
				 if(isOnlineOldValue === false && onLineValue === true){
					  if($s.syncingBackOnline === false){
						  $s.syncingBackOnline = true;
						  $s.syncInProgress = true;
						  $s.checkF360SyncStatus().then(function(){
							 $s.syncingBackOnline = false;
							 $s.syncInProgress = false;
						
						  });
					  } 
				 }
				 
			 });

			 $s.checkF360SyncStatus = function checkF360SyncStatus() {
				var syncStatusPromise = $q.defer();
				if ($s.isOnline && $s.updateInProgress === false) {


					
					log.info("checkSync: Synch in Progress");

					auditService.getIndexDBListByHerdId(function getF360List(err, data){
						
						if(err){
							log.error("There was err in getting cached list : "+err);
							syncStatusPromise.reject(true);
							MSF.loadPage('Fertility360report');
						}

						var activeAuditListData = _.find(data,{AuditId: self.auditId});
						var lastSyncedDate = _.get(activeAuditListData,'SyncedOn',null);
						if(_.isEqual(lastSyncedDate,"")){
							lastSyncedDate = null;
						}
							
					   var  isDeviceDirty = _.get(activeAuditListData,'IsDeviceDirty',false);
					   
					     //if the check sync is in progress, but an update answer/notes occurs , we need to cancel this interval of check sync
						 if(	$s.updateInProgress === true){
							log.info("Section Page : a save has started before calling getSyncedSatus canceling this interval of check sync");
							syncStatusPromise.reject(true);
							   return;
						   }

					   log.info("check Sync: calling getSyncStatus with lastSyncedDate: "+lastSyncedDate+" and isDeviceDirty: "+isDeviceDirty);
					   api.getSyncStatus(self.auditId,lastSyncedDate,isDeviceDirty, function getF360SyncStatus(err, data) {
								if (err) {
									self.isSync = false;
									log.error('error getting F360 online check: ' + err);
								}

								  //if the check sync is in progress, but an update answer/notes occurs , we need to cancel this interval of check sync
								  if(	$s.updateInProgress === true){
									log.info("Section Page : a save has started after calling getSyncedSatus canceling this interval of check sync");
									syncStatusPromise.reject(true);
									   return;
								   }
								
								if (data) {
									self.isSync = true;
								
									var syncData = data[0];	

									if(!_.isUndefined(syncData)){
										//	 _.set(data,'updateDevice',true);	
										log.info("checkedSync: synce data returned with");
										log.info(syncData);
										if((_.isEqual(_.get(syncData,'ToUpdateServer'),true)) || (_.isEqual(_.get(syncData,'ToUpdateServer').toLowerCase(),"true"))){

											log.info("checkedSync: server needed updating");
											auditService.updateServerAuditData(self.auditId,function(err,data){
												if (err) {
													log.error('error updating server with device data: ' + err);
													$s.isDirty = true;
												}else{
													$s.isDirty = false;
												}
												log.info("update server complete");
												// we need to update the IsDeviceDirty flag of the audit in IndexDB
												auditService.updateIsDirty(self.auditId,$s.isDirty,function getIsDirtyUpdate(err, data){
													if (err) {
														log.error('error updateing isDirty flag: ' + err);
													}
													log.info("checkedSync: update IsDeviceDirty complete");
													// we need to call up the database version of SyncedOn because the update server proccess sets a more current SyncedOn on the server side
													auditService.getListByHerdId(function getF360ListByHerdId(err, data) {
														var auditlistItem = _.find(data,{AuditId: self.auditId});
	
														log.info("checkedSync: updating last synced date with : ");
														log.info(auditlistItem);
	
														 //if the audit was deleted ,the record won't be in IndexedDB and doesn't need SyncedOn updated
														if(!_.isUndefined(auditlistItem)){ 
															auditService.updateLastSyncedDate(self.auditId,_.get(auditlistItem,'SyncedOn'),function getUpdateLastSyncDateData(err,data){
																if (err) {
																	log.error('error updating server with device data: ' + err);
																}
																
																log.info("checkedSync: last synced date update complete , sync end");
																syncStatusPromise.resolve(true);
																
			
															});	 
														}else{
															log.info("checkedSync: audit was deleted . so no need to update last synced date. sync end ");
															syncStatusPromise.resolve(true);
														}
		
													});
												});
												
												
	
											});
										}else{
										   // the device's SyncedOn Date is older than the server's copy of the same property and the device needs updating
											log.info("checkSync: server is up to date , need to check if device needs updating");
												if((_.isEqual(_.get(syncData,'ToUpdateDevice'),true)) || (_.isEqual(_.get(syncData,'ToUpdateDevice').toLowerCase(),"true"))){
													log.info("checkSync: device needs updating , setting device update flag true , sync end");
												
													 // if the device needs updating then we need to send the user back to the f360 dashboard to attempt a device sync after prompt
													syncStatusPromise.reject(true);
													MSF.loadPage('Fertility360report');
												}else{
													log.info("checkSync: no server update needed , sync end");
													syncStatusPromise.resolve(true);
												}
											  
										}
									} else {
										log.info("checkedSync: no getSyncedStatus data returned , sync end");
										self.isSync = false;
										syncStatusPromise.resolve(true);
									}

								} else {
									self.isSync = false;
									syncStatusPromise.resolve(true);
								}	
							});
						});
				} else {
					self.isSync = false;
					syncStatusPromise.resolve(true);
				}
				return syncStatusPromise.promise;
			}
		

			$s.$on("$destroy", function() {
		
				deregOnFarmChange();
				deregOnlineCheckWatch();
			});
			
			deregOnFarmChange =	$s.$on('farm:changed',function(){
									MSF.loadPage('Fertility360report');
								});
			MSF.ready(function onMsfReady() {
				$s.codeFile = _.cloneDeep(_.get(MSF,'lists.codeFile',[]));
				try{
					var actionItemGroupTemplateDetailsJsonArray = JSON.parse(_.get(_.find($s.codeFile,{codeType: "JSONTEMPLATES",code:"TMPLF360ACTITMGRP"}),'detailsJson'));
					var  maxActionItemGroupTemplateApiVer = _.max(
						_.map(actionItemGroupTemplateDetailsJsonArray,function(actionItemGroupTmplDetailsVersion){
							var apiVerNumStr = _.get(actionItemGroupTmplDetailsVersion,'apiVersion').replace("v","");
							return parseFloat(apiVerNumStr);
						})
					); 
					
					$s.actionItemGroupTmpl =  _.get(_.find(actionItemGroupTemplateDetailsJsonArray,{apiVersion:`v${maxActionItemGroupTemplateApiVer}`}),'template');

				}catch(e){
					log.info("Review Draft Page: Action Item Group Template failed to be acquired from Code File or failed to be parsed");
				}

				try{
					var actionItemTemplateDetailsJsonArray = JSON.parse(_.get(_.find($s.codeFile,{codeType: "JSONTEMPLATES",code:"TMPLF360ACTITM"}),'detailsJson'));
					var  maxActionItemTemplateApiVer = _.max(
						_.map(actionItemTemplateDetailsJsonArray,function(actionItemTmplDetailsVersion){
							var apiVerNumStr = _.get(actionItemTmplDetailsVersion,'apiVersion').replace("v","");
							return parseFloat(apiVerNumStr);
						})
					); 
					
					$s.actionItemTmpl =  _.get(_.find(actionItemTemplateDetailsJsonArray,{apiVersion:`v${maxActionItemTemplateApiVer}`}),'template');

				}catch(e){
					log.info("Review Draft: Action Item Group Template failed to be acquired from Code File or failed to be parsed");
				}
				//local storage data 	
				var mySynchStateJSON = localStorage.getItem('MySynch-state');
				if(!_.isUndefined(mySynchStateJSON)){
					$s.mySynchState = JSON.parse(mySynchStateJSON);

					$s.activeFarm = _.get($s.mySynchState,'value.activeFarm',{});
				}

				auditService.getActiveOrCurrentAuditVersion().then(function(apiVersion){
					$s.auditApiVersion = apiVersion;
			    });

				// first we want to check if the user has permissions to view this page/audit
				$s.checkPermissions(function(){
					// then we have to check if the server or the device needs updating 
					$s.syncInProgress = true;
					$s.initCheckSyncInProgress = true;
					$s.checkF360SyncStatus().then(function(){
						$s.syncInProgress = false;
						$s.initCheckSyncInProgress = false;
						// then as long as the user wasn't kicked back to the dashboard, continue to load this screen's data
						loadCurrentHerd(function(){
							loadReportData();
						});				
						
					});

				});
			
			});
		}
	]);
})();
